import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {



	constructor(private http: HttpClient) { }
	url = environment.serverAPI4 + "/api";
	url2 = environment.serverAPI8 + "/api";




	getConfigDataNew(): Observable<Object> {
		return this.http.get(`${this.url}/config/new`);
	}

	
	getKey(): Observable<Object> {
		return this.http.get(`${this.url}/ig/config/new`);
	}


	public responseCache = new Map();

	// getConfigData(): Observable<Object> {			
	// 	const configFromCache = this.responseCache.get(`${this.url}/config`);
	
	// 	if (configFromCache) {
	// 		return of(configFromCache);
	// 	} else {
	// 		return this.http.get<any>(`${this.url}/config`).pipe(
	// 			tap(config => this.responseCache.set(`${this.url}/config`, config))
	// 		);
	// 	}
	// }

	saveConfigMain(config: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/config`, config);
	}

	saveConfig(config: any): Observable<any> {
		return this.http.post<any>(`${this.url}/coreConfigDataDuplicate`, config).pipe(
			tap(() => this.delete())
		);
	}
	
	delete(){
		this.responseCache.delete(`${this.url}/config`)
	}


	
	// setClientID(p0: { clientId: any; }): Observable<Object> {
	// 	return this.http.post(`${this.url2}/connectDevice`);
	// }
	// this.basicAuthenticationService.getStorageToken(
	// 			  Constant.XSRF_TOKEN
	// 			);
	
	setClientID(config: any): Observable <Object>  {
		return this.http.post<Response[]>(`${this.url2}/connectDeviceID`, config);
	}

	setRunningTask(taskId: any, clientId?: any): Observable<Object> {
		const payload: any = { 
			timeSheetId: taskId,
			taskId: taskId
		};
		if (clientId) {
			payload.clientId = clientId;
		}
		return this.http.post(`${this.url2}/runningTask`, payload);
	}

	clearRunningTask(clientId?: any, taskId?: any): Observable<Object> {
		const payload: any = {};
		if (clientId) {
			payload.clientId = clientId;
		}
		if (taskId) {
			payload.taskId = taskId;
		}
		return this.http.post(`${this.url2}/runningTask/clear`, payload);
	}
}
